import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

function useReceiptCategories() {
  const receiptCategories = useSelector((store: AppState) => store.auth.selectedCompany.receiptCategories ?? []);

  const receiptCategoriesAutoCompleteItems: AutocompleteListItem[] =
    receiptCategories.map((item) => ({
      id: item.id,
      value: item.name ?? " ",
      data: item,
      group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
    })) ?? [];

  const receiptCategoriesSelectItems: SelectInputItemProps[] = receiptCategories.map((i) => ({
    value: i.id!,
    label: i.name ?? " ",
    group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
    data: i,
  }));

  return {
    receiptCategories,
    receiptCategoriesAutoCompleteItems,
    receiptCategoriesSelectItems,
  };
}

export default useReceiptCategories;
